import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {IColumnChartData} from '../column-money-chart/column-money-chart.component';
import { IObject } from '../../shared/models/models';
import {ServerService} from '../../shared/services/server.service';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-widget-finance-graphic',
  templateUrl: './widget-finance-graphic.component.html',
  styleUrls: ['./widget-finance-graphic.component.scss']
})

export class WidgetFinanceGraphicComponent implements OnInit, OnDestroy{

  public loading: boolean = false;
  @Input() object: IObject = null;

  data: {
      baiterek: number,
      mio: number,

      bar: IColumnChartData,
      pie: {
          firstPercent: number,
          plan: number,
          purchased: number,
          secondPercent: number,
      }
  };

  pieData: any = {};

  constructor( public server: ServerService) {
  }

  ngOnInit() {
    this.loadData(this.object.city.id, this.object.id);
  }

  ngOnDestroy(){
  }

  coef():number{
    return 1.5;
  }

  loadData(cityId: number, complexId: number):void{
    this.server.getFinanceObjectData(cityId, complexId).then( data => {
      this.data=data;
      let onePercent = this.data.pie.plan/100;
      
      this.pieData={
        purple: this.data.mio/onePercent/100,
        thinDarkPurple: this.data.mio/onePercent/100,
        thinPurple: this.data.mio/onePercent*this.data.pie.secondPercent/10000,
        thinBlue: this.data.baiterek/onePercent*this.data.pie.firstPercent/10000,
          pTextX: Math.cos((270-360*this.data.mio/onePercent*this.data.pie.secondPercent/10000)/57.2958),
          pTextY: Math.sin((270-360*this.data.mio/onePercent*this.data.pie.secondPercent/10000)/57.2958),
          bTextX: Math.cos((270+360*this.data.baiterek/onePercent*this.data.pie.firstPercent/10000)/57.2958),
          bTextY: Math.sin((270+360*this.data.baiterek/onePercent*this.data.pie.firstPercent/10000)/57.2958),
      };
    },
    error => {
    });
  }

  getObjectPhoto(): string {
    return 'url('+ environment.apiUrl + 'BuildingFiles/DownloadFile?fileID=' + this.object.photo_id + '&isThumb=' + true + '&data='+')';    
  }
}
